/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelledAppointments/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CancelledAppointments({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Reporting/Content/CancelledAppointments"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let statisticsCancelledAppointmentsValueData = fromData.useDataValue({ viewPath,
context: 'statistics',
path: 'cancelled_appointments',
})
let dtTypographyFontweightBold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.bold'
        })
  return (<React.Fragment
>
<div
  data-testid="CancelledAppointments.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-6fOGM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Cancelled:"
 fontSize={dtTypographyFontsizeM}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral700}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="statistics.cancelled_appointments"
 text={statisticsCancelledAppointmentsValueData}
 marginLeft={dtSpaceXs}
 fontWeight={dtTypographyFontweightBold}
/>
</div>
{children}
</React.Fragment>)
}